module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"Hourly Trends":"Hourly Trends","Daily Trends":"Daily Trends","Occupancy":"Occupancy","AverageOccupancy":"Average Occupancy","Staff":"Staff","In":"In","Out":"Out"}}')
  delete Component.options._Ctor
}
